/* eslint-disable import/no-unresolved */
import { Swiper, Navigation, A11y } from 'swiper';

const SLIDE_SPEED = 500;

function setNavDisabled(btn, disabled) {
  btn.classList.toggle('disabled', disabled);
  // eslint-disable-next-line no-param-reassign
  btn.disabled = disabled;
  btn.setAttribute('aria-disabled', disabled ? 'true' : 'false');
}

function createNavSync(prevEl, nextEl) {
  return (swiper) => {
    setNavDisabled(prevEl, swiper.isBeginning);
    setNavDisabled(nextEl, swiper.isEnd);
  };
}

function initCardGatheringSlider(cardEl) {
  const swiperEl = cardEl.querySelector('.card-gathering__swiper');
  const prevEl = cardEl.querySelector('.card-gathering__nav--prev');
  const nextEl = cardEl.querySelector('.card-gathering__nav--next');

  if (!swiperEl || !prevEl || !nextEl) {
    return;
  }

  const slideCount = swiperEl.querySelectorAll('.swiper-slide').length;

  if (slideCount <= 1) {
    return;
  }

  swiperEl.swiper?.destroy(true, true);

  const updateNav = createNavSync(prevEl, nextEl);

  const swiper = new Swiper(swiperEl, {
    modules: [Navigation, A11y],
    slidesPerView: 1,
    spaceBetween: 0,
    loop: false,
    watchOverflow: true,
    speed: SLIDE_SPEED,
    navigation: {
      prevEl,
      nextEl,
      disabledClass: 'disabled',
    },
    a11y: {
      enabled: true,
      prevSlideMessage: 'Previous slide',
      nextSlideMessage: 'Next slide',
    },
    on: {
      init: updateNav,
      resize: updateNav,
      slideChange: updateNav,
      fromEdge: updateNav,
    },
  });

  swiperEl.addEventListener('focusin', (event) => {
    const slide = event.target.closest('.swiper-slide');

    if (!slide) {
      return;
    }

    const index = Array.from(swiper.slides).indexOf(slide);

    if (index !== -1 && index !== swiper.activeIndex) {
      swiper.slideTo(index);
    }
  });
}

function initCardGatheringRoot(rootEl) {
  rootEl.querySelectorAll('.card-gathering__card--slider').forEach((cardEl) => {
    initCardGatheringSlider(cardEl);
  });
}

function initAllCardGatherings() {
  document.querySelectorAll('.card-gathering').forEach((rootEl) => {
    initCardGatheringRoot(rootEl);
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initAllCardGatherings();

  if (window.acf) {
    window.acf.addAction('render_block_preview/type=azds-card-gathering', () => {
      initAllCardGatherings();
    });
  }
});
